<template>
  <v-row no-gutters
    align="start"
    justify="center"
    class="control-toolbar print-preview-toolbar secondary">
    <v-checkbox
      class="checkbox"
      v-model="headerToggle"
      :color="colorHex"
      primary
      hide-details
      label="Include Headers"
      @click.stop="toggleHeader"/>
    <select-with-button
      selection-prefix="Images Per Sheet:"
      :value="imagesPerSheet"
      @change="setImagesPerSheet"
      :items="imagesPerSheetOptions"
      :icon-button="true"
      class="toolbar-select"/>
    <v-checkbox
      v-if="!isSafari"
      class="checkbox"
      v-model="isLandscape"
      :color="colorHex"
      primary
      hide-details
      label="Landscape"
      @click.stop="setLayout('landscape')"/>
    <v-checkbox
      v-if="!isSafari"
      class="checkbox"
      v-model="isPortrait"
      :color="colorHex"
      primary
      hide-details
      label="Portrait"
      @click.stop="setLayout('portrait')"/>
    <v-btn text 
      class="modal-cta mx-1"
      :disabled="isLoadingImages"
      @click.stop="print">Print</v-btn>
    <v-btn text
      v-if="!hideCloseButton" 
      class="modal-cta mx-1"
      @click="$emit('closePrintPreview')">Cancel</v-btn>
  </v-row>
</template>

<script>

import selectWithButton from "../controls/SelectWithButton";
import { mapGetters } from "vuex";

export default {
  name: "printPreviewBrowserToolbar",
  data() {
    return {
      imagesPerSheetOptions: [ 
        { value: 1, text: "1" },
        { value: 4, text: "4" },
        { value: 9, text: "9" },
        { value: 16, text: "16" }
      ]
    }
  },
  components: { selectWithButton },
  props: {
    hideCloseButton: Boolean
  },
  computed: {
    ...mapGetters([
      "printPreviewContext", 
      "printPreviewPageLayout", 
      "printPreviewDisplayHeader", 
      "printPreviewImagesPerSheet", 
      "printPreviewCurrentPage", 
      "printPreviewImageNum",
      "printPreviewIsPrinting",
      "isLoadingAppPrintImages",
      "isSafari"]),
    imagesPerSheet() {
      return this.printPreviewImagesPerSheet;
    },
    headerToggle() {
      return this.printPreviewDisplayHeader;
    },
    isPortrait() {
      return this.layoutToggle("portrait");
    },
    isLandscape() {
      return this.layoutToggle("landscape");
    },
    currentPage() {
      return this.printPreviewCurrentPage;
    },
    isLoadingImages() 
    {
      return this.isLoadingAppPrintImages;
    }
  },
  methods: {
    handleCheckboxClick() {
      this.$store.commit("togglePrintPreviewHeaders");
    },
    setLayout(layout) {
      this.$store.commit("setPrintPreviewPageLayout", layout);
    },
    layoutToggle(layout) {
      return this.printPreviewPageLayout == layout;
    },
    setImagesPerSheet(num) {
      this.$store.commit("setPrintPreviewImagesPerPage", num);
      this.$store.commit("setPrintPreviewSheetNum", (Math.ceil(this.printPreviewImageNum / this.printPreviewImagesPerSheet) > 0 ? Math.ceil(this.printPreviewImageNum / this.printPreviewImagesPerSheet) : 1));
    },
    toggleHeader() {
      this.$store.commit("togglePrintPreviewHeaders");
    },
    changePage(direction) {
      if (direction == "right")
        this.$store.commit("incrementPrintPreviewCurrentPage"); 
      else 
        this.$store.commit("decrementPrintPreviewCurrentPage");
    },
    print() {
      if (this.printPreviewIsPrinting) return;
      this.$store.commit("startPrinting");
      this.$nextTick().then(() => this.printPreviewContext.print())
        .finally(() => this.$store.commit("stopPrinting"));
    }
  }
}
</script>
